import { Brand } from '@anm/api/modules/brands';
import { SelectOption } from '@anm/components/select/Select';
import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';

import { BrandLogo } from './Wrapper';

type UseSelectOptionsProps = {
  brandList: Brand[];
  currentBrandId?: number;
};

export const useSelectOptions = ({ brandList, currentBrandId }: UseSelectOptionsProps) => {
  const options = brandList.map(({ name, id, textColors, logos }) => ({
    label: name,
    value: id,
    renderIcon: () =>
      isEmpty(logos) ? (
        <BrandLogo color={textColors[0]?.background.color}>{name.slice(0, 1)}</BrandLogo>
      ) : (
        <BrandLogo as="img" src={logos[0].preview} alt="brand logo" />
      )
  }));

  const [brandId, setBrandId] = useState<number>(currentBrandId || 0);

  const brandIndex = options.findIndex(b => b.value === brandId)!;
  const currentValue = options[brandIndex];
  const logos = brandList.find(b => b.id === brandId)?.logos;

  const handleSelectChange = useCallback(({ value }: SelectOption) => setBrandId(value), []);

  return [options, currentValue, logos, handleSelectChange] as const;
};
